import { trpc } from '@bitbot/api';
import { createGlobalStore } from 'hox';
import { useMemo, useLayoutEffect } from 'react';
import { useLocalStorageState } from 'ahooks';
import { useLaunchParams, useThemeParams } from '@bitbot/shared/bridge'
import { useTranslation } from 'next-i18next';
import { useToken } from './token';
import { useWallets } from '../wallet';

export type theme = 'system' | 'light' | 'dark';

type languageType = 'en' | 'zh-CN';
export const languages: { name: string; value: languageType }[] = [
  {
    name: 'English',
    value: 'en',
  },
  {
    name: '简体中文',
    value: 'zh-CN',
  },
];

export const [useProfile] = createGlobalStore(() => {
  const { t, i18n } = useTranslation();
  const { walletsInfo } = useWallets();
  const launchParams = useLaunchParams();
  const themes: { name: string; value: theme }[] = [
    {
      name: t('profile.followSystem'),
      value: 'system',
    },
    {
      name: t('profile.dayMode'),
      value: 'light',
    },
    {
      name: t('profile.nightMode'),
      value: 'dark',
    },
  ];
  const { hasLogin } = useToken();
  // const themeParams = useThemeParams();
  const [theme, setTheme] = useLocalStorageState<theme>('theme', {
    defaultValue: 'system',
  });

  const [realTheme, setRealTheme] = useLocalStorageState<theme>(
    'realTheme',
    {
      defaultValue: 'system',
    },
  );

  const { language } = i18n;
  const {
    data: userInfo,
    refetch: refetchUserInfo,
    isLoading: gettingUserInfo,
  } = trpc.user.getUserInfo.useQuery(undefined, {
    enabled: hasLogin,
  });
  const languageName = useMemo(() => {
    for (let lang of languages) {
      if (lang.value === i18n.language) return lang.name;
    }
  }, [i18n]);

  useLayoutEffect(() => {
    if (theme === 'system') {
      setRealTheme('dark');
      // if (themeParams.isDark) {
      //   setRealTheme('dark');
      // } else {
      //   setRealTheme('light');
      // }
    } else {
      setRealTheme(theme);
    }
  }, [theme]);

  // const realTheme = useMemo(() => {
  //   if (theme === 'system') {
  //     if (themeParams.isDark) return 'dark';
  //     return 'light';
  //   }
  //   return theme;
  // }, [theme]);

  const switchLanguage = (lang: languageType) => {
    if (lang === language) {
      return;
    }
    window.location.href = `/${lang}`;
  };

  return {
    displayId: walletsInfo?.displayId ?? '',
    userInfo,
    theme,
    themes,
    setTheme,
    realTheme,
    languages,
    language,
    languageName,
    setLanguage: switchLanguage,
    refetchUserInfo,
    gettingUserInfo,
    email: walletsInfo?.email,
    isEmailEnabled: walletsInfo?.isEmailEnabled,
    uid: launchParams?.initData?.user?.id ?? '',
  };
});
